(() => {
  const picker = document.querySelector('[data-review-product-picker]');
  const search = picker?.querySelector('[data-review-search]');
  if (search) {
    const results = picker.querySelector('[data-review-search-results]');
    const message = picker.querySelector('[data-review-search-status]');
    const clear = picker.querySelector('[data-review-search-clear]');
    let timer;
    let controller;
    let revision = 0;
    const resetResults = () => {
      results.replaceChildren();
      results.hidden = true;
    };
    const invalidate = () => {
      clearTimeout(timer);
      controller?.abort();
      revision += 1;
      picker.removeAttribute('aria-busy');
      resetResults();
      clear.hidden = !search.value;
      return revision;
    };
    const productLink = (value) => {
      try {
        const url = new URL(value, window.location.origin);
        if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname)) return null;
        url.search = '';
        url.hash = 'write-review';
        return url.href;
      } catch (_) { return null; }
    };
    const runSearch = async (query, requestRevision) => {
      controller = new AbortController();
      picker.setAttribute('aria-busy', 'true');
      message.textContent = picker.dataset.searchLoading;
      try {
        const url = new URL(picker.dataset.searchUrl, window.location.origin);
        if (url.origin !== window.location.origin) throw new Error('Invalid search endpoint');
        url.searchParams.set('q', query);
        url.searchParams.set('resources[type]', 'product');
        url.searchParams.set('resources[limit]', '10');
        url.searchParams.set('resources[options][unavailable_products]', 'show');
        const response = await fetch(url.href, { signal: controller.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (requestRevision !== revision) return;
        const products = data.resources?.results?.products;
        if (!Array.isArray(products)) throw new Error('Invalid search response');
        const fragment = document.createDocumentFragment();
        const seen = new Set();
        products.slice(0, 10).forEach((product) => {
          const href = productLink(product.url);
          if (!href || !product.title || seen.has(href)) return;
          seen.add(href);
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'tis-review-search__result';
          link.href = href;
          const media = document.createElement('span');
          media.className = 'tis-review-search__image';
          media.setAttribute('aria-hidden', 'true');
          try {
            const source = product.featured_image?.url || product.image;
            if (!source) throw new Error('No product image');
            const imageUrl = new URL(source, window.location.origin);
            if (imageUrl.protocol === 'https:' && (imageUrl.origin === window.location.origin || imageUrl.hostname === 'cdn.shopify.com')) {
              imageUrl.searchParams.set('width', '144');
              const image = document.createElement('img');
              image.src = imageUrl.href;
              image.alt = '';
              image.width = 64;
              image.height = 64;
              image.loading = 'lazy';
              media.append(image);
            }
          } catch (_) { /* A missing image must not hide a purchased design. */ }
          const copy = document.createElement('span');
          const title = document.createElement('strong');
          title.textContent = product.title;
          const action = document.createElement('span');
          action.className = 'tis-review-search__action';
          action.textContent = picker.dataset.searchAction;
          copy.append(title, action);
          link.append(media, copy);
          item.append(link);
          fragment.append(item);
        });
        results.replaceChildren(fragment);
        results.hidden = !seen.size;
        message.textContent = !seen.size ? picker.dataset.searchEmpty : products.length >= 10 ? picker.dataset.searchLimit : picker.dataset.searchResults;
      } catch (error) {
        if (requestRevision !== revision || error.name === 'AbortError') return;
        resetResults();
        message.textContent = picker.dataset.searchError;
      } finally {
        if (requestRevision === revision) picker.removeAttribute('aria-busy');
      }
    };
    const update = (immediate = false) => {
      const requestRevision = invalidate();
      const query = search.value.trim();
      message.textContent = picker.dataset.searchIdle;
      if (query.length < 2) return;
      if (immediate) runSearch(query, requestRevision);
      else timer = setTimeout(() => runSearch(query, requestRevision), 250);
    };
    search.addEventListener('input', (event) => {
      if (event.isComposing) { invalidate(); return; }
      update();
    });
    search.addEventListener('compositionend', () => update());
    picker.addEventListener('submit', (event) => { event.preventDefault(); update(true); });
    clear.addEventListener('click', () => { search.value = ''; update(); search.focus({ preventScroll: true }); });
  }

  if (window.location.hash !== '#write-review') return;
  const host = document.querySelector('#TisProductReviews');
  const status = document.querySelector('[data-review-start-status]');
  if (!host || !status) return;
  status.hidden = false;
  host.scrollIntoView({ block: 'start', behavior: 'instant' });
  let started = false;
  let observer;
  let timeout;
  const openNativeForm = () => {
    const button = host.querySelector('[data-testid="write-review-button"], .jm-action-buttons__button.jm-button--primary, .jdgm-write-rev-link');
    if (started || !button || button.disabled || button.getAttribute('aria-disabled') === 'true') return false;
    started = true;
    observer?.disconnect();
    clearTimeout(timeout);
    status.hidden = true;
    // Keep Judge.me in charge of ratings, validation, identity and submission.
    button.click();
    return true;
  };
  if (openNativeForm()) return;
  observer = new MutationObserver(openNativeForm);
  observer.observe(host, { childList: true, subtree: true });
  timeout = setTimeout(() => {
    observer.disconnect();
    if (!started) status.textContent = 'The review form is taking longer to load. Choose “Write a review” below when it appears, or refresh this page to try again.';
  }, 15000);
})();
